import http from "./http";

class ModepaiementsService {
    index(token){
        return http.get("/api/modepaiements", { headers: { "Content-Type": "multipart/form-data",'Authorization': 'Bearer '+token  } })
    }

    index_modepaiements(){
        return http.get("/api/liste_modepaiements")
    }

    store(data,token){
        return http.post("/api/modepaiements/store", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    edit(id,token){
        return http.get(`/api/modepaiements/${id}/edit`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return http.get(`/api/modepaiements/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(id, data,token){
        return http.post(`/api/modepaiements/${id}/update`, data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return http.delete(`/api/modepaiements/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new ModepaiementsService()